'use strict'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import MergeDropdownComponent from '../commonComponents/MergeDropdownComponent';
import LoadingComponent from '../commonComponents/LoadingComponent';
import CallAPI from '../commonComponents/AxiosHelper';
import { connect } from 'react-redux';
import { ButtonComponent } from '../../../src/components/commonComponents/UIComponent';
import ErrorComponent from '../commonComponents/ErrorComponent';
import SearchSelect from '../commonComponents/SearchSelect';


class StepTwo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            itemData:[],
            item:{

            },
            selectedItems: {

            },
            selectedItemData:[]
        }

        this.nextAction = this.nextAction.bind(this);
        this.backAction = this.backAction.bind(this);
        this.handleChange = this.handleChange.bind(this);
        // this.getTableColumns = this.getTableColumns.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);

    }

    componentWillMount() {
        let combined_data = [...this.props.stepData.state.selectedTable['transaction'], ...this.props.stepData.state.selectedTable['master']];
        // let final_data = this.props.stepData.getTableColumns(combined_data);
        this.setState({
            data:combined_data
        })
    }

    backAction() {
        this.props.stepData.handleBackTrack(this);
    }
    nextAction() {
        this.props.stepData.handleSteps(this);
    }

    handleChange(selectedValue,reference){
        if (selectedValue.length !== 0) {
            this.props.stepData.getIncludedColumns(selectedValue);
        }
    }

    handleTableChange(e,reference){
        // let itemData = [];
        let item = this.state.item;
        // let selectedItems = this.state.selectedItems;
        let selectedItems = this.props.stepData.state.selectedItems;

        let filteredTable = reference.props.dropdownConfig.dropdownData.filter((element, i) => {
            return e.target.value == element.value;
        });
        if (item[filteredTable[0]['value']] == null || item[filteredTable[0]['value']] == undefined){
            item[filteredTable[0]['value']] = filteredTable;
        }
        let selectedItemData = (selectedItems[filteredTable[0]['value']] !== null && selectedItems[filteredTable[0]['value']] !== undefined)?selectedItems[filteredTable[0]['value']]:[];
        // itemData.push(filteredTable[0]);
        this.setState({
            // itemData: itemData,
            itemData: item[filteredTable[0]['value']],
            item:item,
            selectedItemData: selectedItemData
        })
        
    }


    render() {

        let table_array = {
            "class": "col-md-4 mg-y-3",
            "id": "table_columns",
            "placeholder": "Select table to exclude columns",
            "size": 5,
            "dropdownData": this.state.data,
            "subtext": true,
            "value": [],
            "valueFlag": false
        };

        var itemData = (this.state.itemData.length !== 0) ? this.state.itemData[0].columnConfig:[];


        let multiSelect_array = {
            "class": "col-md-4",
            "itemData": itemData,
            "label_value":"name",
            "selectedItems": (this.state.selectedItemData.length == 0)?itemData:this.state.selectedItemData
        }
        let backButton = { "name": "Back", "event":this.backAction };

        return (
            <>
                <div className="card">
                    <div className="card-header">
                        <div className="d-flex flex-row justify-content-between">
                            <ButtonComponent buttonData={backButton} />
                            <button className="btn btn-primary btn-sm text-white" onClick={this.nextAction}>Next</button>
                        </div>
                    </div>
                    <div className="card-body">
                        <span className="mb-1 mg-l-15">Select table to exclude columns:</span>
                        <MergeDropdownComponent dropdownConfig={table_array} onChange={this.handleTableChange} />
                        <SearchSelect selectConfig={multiSelect_array} handleChange={this.handleChange} />
                    </div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return { tableData: state.admin.tableData };

}


// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({
//         setToolId
//     }, dispatch)
// }

export default connect(mapStateToProps, null)(StepTwo);
// export default DataMerge;

